import { gql } from "@apollo/client";

export const QUERY_PROFILE_BY_USERNAME = gql`
  query Query($username: String!) {
    user(username: $username) {
      id
      _id
      username
      admin
      avatar
      createdDate
      rank
      userGroup {
        type
      }
      profile {
        username
        createdDate
        following
        profile {
          countryCode
          socials {
            youtube
            twitch
            tiktok
            twitter
            instagram
            steam
          }
        }
      }
      clipCount
      followerCount
      followingCount
      pinnedClips {
        id
        thumbnailUrl(style: OVERLAY)
        isPinned
        title
        shareId
        createdAt
        views
        previewUrl
        user {
          _id
          username
          avatar
        }
      }
      tiktok {
        avatar
        display_name
      }
      steam {
        personaname
        steamid
      }
      riot {
        puuid
      }
    }
  }
`;

export const QUERY_PROFILE = gql`
  query Query($user: String) {
    userProfile(user: $user) {
      profile {
        following
        createdDate
        profile {
          youtubeChannels
          socials {
            youtube
            twitch
            tiktok
            twitter
            instagram
            steam
          }
          locale
          countryCode
        }
        username
      }
      stats {
        totalClips
        totalViews
      }
      user {
        pinnedClips {
          id
          thumbnailOverlayUrl: thumbnailUrl(style: OVERLAY)
          thumbnailStandardUrl: thumbnailUrl(style: STANDARD)
          isPinned
          title
          shareId
          createdAt
          views
          previewUrl
          user {
            _id
            username
            avatar
          }
        }
        id
        admin
        avatar
        createdDate
        _id
        rank
        userGroup {
          type
        }
        username
        tiktok {
          avatar
          display_name
        }
        steam {
          personaname
          steamid
        }
        riot {
          puuid
        }
      }
    }
  }
`;
